import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addLeaveApplication = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Leave Application',
    body
  );
  return data;
});
export const updateLeaveApplication = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Leave Application/${id}`,
    body
  );
  return data;
});

export const getLeaveApplication = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Leave Application?fields=["name","status","docstatus","employee_name","from_date","to_date"]&limit_page_length=10&limit_start=0&order_by=creation desc'
  );
  return data;
});
export const deleteLeaveApplication = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Leave Application/${record}`
  );
  return data;
});
export const getLeaveApplicationDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Leave Application/${id}`
  );
  return data;
});
